import { render, staticRenderFns } from "./ClientGrid.vue?vue&type=template&id=3d8fea12"
import script from "./ClientGrid.vue?vue&type=script&lang=js"
export * from "./ClientGrid.vue?vue&type=script&lang=js"
import style0 from "./ClientGrid.vue?vue&type=style&index=0&id=3d8fea12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports